




































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { RootState } from "@/store";

//Components
import ImportTemplateDialog from "@/views/App/SecurityAndConfiguration/SecurityManagement/ImportTemplateDialog.vue";
import ExportTemplateDialog from "@/views/App/SecurityAndConfiguration/SecurityManagement/ExportTemplateDialog.vue";
import ActualConfigurationDialog from "@/views/App/SecurityAndConfiguration/SecurityManagement/ActualConfigurationDialog.vue";
import RevertConfigurationDialog from "@/views/App/SecurityAndConfiguration/SecurityManagement/RevertConfigurationDialog.vue";

//Model
import { Configuration, Stock } from "@/model/data/security/Configuration";
import {
    EditInstallationSecurityConfigurationCommand,
    EditInstallationSecurityConfigurationReqData,
} from "@/model/communication/security/EditInstallationsSecurityConfigurationCommand";
import { ConfigurationSecurity } from "@/model/data/security/ConfigurationSecurity";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { ImportTemplateCommand, ImportTemplateReqData } from "@/model/communication/security/ImportTemplateCommand";
import { ImportTemplateResData } from "@/model/communication/security/ImportTemplateResData";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { ExportTemplateCommand, ExportTemplateReqData } from "@/model/communication/security/ExportTemplateCommand";
import { GetImportableTemplateCommand, GetImportableTemplateReqData } from "@/model/communication/security/GetImportableTemplateCommand";
import { GetImportableTemplateResData } from "@/model/communication/security/GetImportableTemplateResData";
import { UpdateSecurityConfigurationNowCommand, UpdateSecurityConfigurationNowReqData } from "@/model/communication/security/UpdateSecurityConfigurationCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { StockTypeEnum } from "@/model/data/enums/StockTypeEnum";
import { GetStockImageReqData, GetStockImageCommand } from "@/model/communication/security/GetStockImageCommand";
import { GetStockImageResData } from "@/model/communication/security/GetStockImageResData";
import { InstallationStocksConfiguration } from "@/model/data/security/InstallationStocksConfiguration";
import { Denomination } from "@/model/data/Denomination";
import { GET_ALL_DENOMINATIONS } from "@/store/modules/ApplicationModule/actions";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { RevertInstallationSecurityConfigurationResData } from "@/model/communication/security/RevertInstallationSecurityConfigurationResData";
import { RevertInstallationSecurityConfigurationCommand } from "@/model/communication/security/RevertInstallationSecurityConfigurationCommand";

export default Vue.extend({
    components: { ImportTemplateDialog, ExportTemplateDialog, ActualConfigurationDialog, RevertConfigurationDialog },
    props: {
        installation: { required: true, type: Object as PropType<InstallationStocksConfiguration> },
        loadingProp: Boolean,
    },
    data() {
        return {
            StockTypeEnum,
            loading: false,
            editMode: false,
            showResetDialog: false,
            showForceDialog: false,
            loadingImage: false,
            stockImage: null,
            localStockConfiguration: null,
            localStockOptions: null,
            selectedStock: 0,
            denominationsToAdd: [],
            denominationsToRemove: [],
            selectedCurrency: this.$t("stocks_config.allCurrencies"),
            shiftKeyOn: false,
            current: [],
            showImportTemplateDialog: false,
            loadingImport: false,
            showExportTemplateDialog: false,
            loadingExport: false,
            importableTemplates: null,
            showActualConfiguration: false,
            alertMessage: "",
            showAlert: false,
            referenceConfiguration: null,
            showRevertDialog: false,
            loadingRevert: false,
        };
    },
    watch: {
        installation: {
            handler(newValue, oldValue) {
                if (this.installation.securityConfigurationReference) this.referenceConfiguration = this.installation.securityConfigurationReference.configuration;
                else if (this.installation.securityConfigurationActual) this.referenceConfiguration = this.installation.securityConfigurationActual.configuration;
                else this.referenceConfiguration = new Configuration();

                if (newValue && newValue.name && oldValue && oldValue.name && newValue.name != oldValue.name) this.showAlert = false;
                this.editMode = false;
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        ...mapState({
            allDenominations: (state: RootState) => state.application.allDenominations,
        }),

        colsQuantity() {
            return this.$vuetify.breakpoint.lgAndUp ? 3 : this.$vuetify.breakpoint.md ? 2 : 1;
        },
        canDeselectCashIn() {
            let canDeselectCashIn = [];
            for (let j = 0; j < this.localStockOptions.length; j++) {
                let stock = this.localStockConfiguration[j];
                let stockOptions = this.localStockOptions[j];
                let found = false;
                if (
                    stock.denominations.length > 1 &&
                    stock.denominations.filter((d) => d.currency == stock.denominations[0].currency && d.value == stock.denominations[0].value).length != stock.denominations.length
                ) {
                    canDeselectCashIn.push(false);
                    found = true;
                } else {
                    for (let i = 1; i < stockOptions.options.length; i++) {
                        if (stockOptions.options[i].isChecked) {
                            canDeselectCashIn.push(false);
                            found = true;
                            break;
                        }
                    }
                }

                if (!found) canDeselectCashIn.push(true);
            }
            return canDeselectCashIn;
        },

        canReadRollsConfig() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadRolls);
        },

        canWriteRollsConfig() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteRolls);
        },

        isDifferentFromDb() {
            if (this.actualConfiguration) return !this.actualConfiguration.isEqual(this.referenceConfiguration, false);
            return false;
        },

        actualConfiguration() {
            return this.installation.securityConfigurationActual ? this.installation.securityConfigurationActual.configuration : new Configuration();
        },

        hasOptions() {
            if (this.installation.rollsProfile.rollsNumber == 0 && this.installation.rollsProfile.hasBag) return false;
            return true;
        },

        serialNumberAndModel() {
            let serialNumberAndModel = "";
            let banknoteMachine = this.installation.machines.filter((m) => m.supportedCashType == CashTypeEnum.Banknote);
            if (banknoteMachine && banknoteMachine.length > 0) serialNumberAndModel = `${banknoteMachine[0].serialNumber} - ${banknoteMachine[0].model}`;
            return serialNumberAndModel;
        },
        canSave() {
            return true;
        },
        stocksConfiguration() {
            if (this.referenceConfiguration) return this.referenceConfiguration.rollsConfig;
            return null;
        },
        stocksOptions() {
            let stockOptions = [];
            if (this.stockConfiguration && this.stockConfiguration.length) {
                for (let stock of this.stockConfiguration) {
                    let options = [];
                    let cashInChecked = stock.cashIn;
                    if (stock.stockType == StockTypeEnum.Bag) cashInChecked = true;
                    if (stock.suspect || stock.counterfeit || stock.unfit) cashInChecked = true;

                    options.push({ label: this.$t("stocks_config.cashIn"), isChecked: cashInChecked });
                    options.push({ label: this.$t("stocks_config.exceed"), isChecked: stock.exceed });
                    options.push({ label: this.$t("stocks_config.suspect"), isChecked: stock.suspect });
                    options.push({ label: this.$t("stocks_config.counterfeit"), isChecked: stock.counterfeit });
                    options.push({ label: this.$t("stocks_config.unfit"), isChecked: stock.unfit });
                    stockOptions.push({ index: stock.index, options: options, type: stock.stockType });
                }
            }
            return stockOptions;
        },

        stockConfiguration() {
            let stockConfiguration = Array<Stock>();
            if (
                this.installation &&
                this.installation.rollsProfile &&
                this.installation.rollsProfile.rollsNumber != null &&
                this.installation.rollsProfile.rollsNumber != undefined
            ) {
                for (let i = 0; i < this.installation.rollsProfile.rollsNumber; i++) {
                    let stock = null;
                    if (this.referenceConfiguration && this.referenceConfiguration.rollsConfig && this.referenceConfiguration.rollsConfig.length) {
                        let s = this.referenceConfiguration.rollsConfig.filter((s) => s.index == i && s.stockType != StockTypeEnum.Bag);
                        if (s && s.length == 1) stock = s[0];
                    }
                    if (stock == null) {
                        stock = new Stock();
                        stock.index = i;
                        stock.stockType = StockTypeEnum.Roll;
                        stock.cashIn = false;
                        stock.exceed = false;
                        stock.unfit = false;
                        stock.counterfeit = false;
                        stock.suspect = false;
                        stock.denominations = new Array<Denomination>();
                    }
                    stockConfiguration.push(stock);
                }
                if (this.installation.rollsProfile.hasBag) {
                    let stock = null;
                    if (this.referenceConfiguration && this.referenceConfiguration.rollsConfig && this.referenceConfiguration.rollsConfig.length) {
                        let s = this.referenceConfiguration.rollsConfig.filter((s) => s.stockType == StockTypeEnum.Bag);
                        if (s && s.length == 1) stock = s[0];
                    }
                    if (stock == null) {
                        stock = new Stock();
                        stock.index = 0;
                        stock.stockType = StockTypeEnum.Bag;
                        stock.cashIn = false;
                        stock.exceed = false;
                        stock.unfit = false;
                        stock.counterfeit = false;
                        stock.suspect = false;
                        stock.denominations = new Array<Denomination>();
                    }
                    stockConfiguration.push(stock);
                }
            }
            return stockConfiguration;
        },
        bag() {
            let bag = null;
            if (this.installation.rollsProfile.hasBag && this.stockConfiguration) {
                let b = this.stockConfiguration.filter((s) => s.stockType == StockTypeEnum.Bag);
                if (b && b.length == 1) bag = b[0];
            }
            return bag;
        },
        selectableStock() {
            let selectableStock = [];
            for (let i = 0; i < this.localStockConfiguration.length; i++) {
                let stock = this.localStockConfiguration[i];
                let text = "";
                if (stock.stockType == StockTypeEnum.Bag) text = this.$t("enum.stockType.bag");
                else if (stock.stockType == StockTypeEnum.NotRecycling) text = this.$t("enum.stockType.notRecycling");
                else if (stock.stockType == StockTypeEnum.Roll) text = this.$t("enum.stockType.roll") + " " + (stock.index + 1);
                selectableStock.push({ value: i, text: text });
            }
            return selectableStock;
        },
        selectableCurrency() {
            let selectableCurrency = [this.$t("stocks_config.allCurrencies")];
            for (let den of this.allDenominations) {
                selectableCurrency.push(den.currency);
            }
            return selectableCurrency;
        },
        filteredDenomination() {
            let filteredDenomination = [];
            for (let den of this.allDenominations) {
                if (den.currency == this.selectedCurrency || this.selectedCurrency == this.$t("stocks_config.allCurrencies")) filteredDenomination.push(den);
            }
            return filteredDenomination;
        },
    },
    methods: {
        ...mapActions([GET_ALL_DENOMINATIONS]),

        cancelConfiguration() {
            this.editMode = false;
            this.showResetDialog = false;
        },

        async getStockImage(stockType: StockTypeEnum, stockIndex: number) {
            this.loadingImage = true;
            try {
                let request = new GetStockImageReqData();
                let banknoteMachine = this.installation.machines.filter((m) => m.supportedCashType == CashTypeEnum.Banknote);
                if (!banknoteMachine || banknoteMachine.length < 1) request.modelName = "";
                else request.modelName = banknoteMachine[0].model;
                request.stockType = stockType;
                request.stockIndex = stockIndex;

                let response: GetStockImageResData = await new GetStockImageCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.stockImage = response.image;
                }
            } catch (e) {
                console.log("Something went wrong sending EditInstallationSecurityConfiguration request ", e);
            }
            this.loadingImage = false;
        },

        async sendRequest(configuration: Configuration) {
            this.loading = true;
            try {
                let request = new EditInstallationSecurityConfigurationReqData();
                request.securityConfiguration = new ConfigurationSecurity();
                request.securityConfiguration.configuration = configuration;
                request.installationName = this.installation.name;
                request.editRools = true;

                let response: ApiGenericResponse = await new EditInstallationSecurityConfigurationCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.savedCorrectly");
                        this.alertType = "success";
                        this.showAlert = true;
                        this.referenceConfiguration = configuration;
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending EditInstallationSecurityConfiguration request ", e);
            }
            this.editMode = false;
            this.loading = false;
            this.$emit("reload-table");
        },

        async importConfiguration(templateId: number, templateName: string) {
            this.editMode = false;
            this.showImportTemplateDialog = false;
            this.loading = true;
            try {
                let request = new ImportTemplateReqData([this.installation.name], templateId);

                let response: ImportTemplateResData = await new ImportTemplateCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.importedCorrectly", { templateName: templateName });
                        this.alertType = "success";
                        this.showAlert = true;
                        this.referenceConfiguration = response.referenceConfiguration.configuration;
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending ImportTemplate request ", e);
            }
            this.loading = false;
            console.log(this.showAlert);
        },
        async exportConfiguration(templateName: string, templateContent: TemplateContentEnum) {
            this.loadingExport = true;
            try {
                let request = new ExportTemplateReqData();
                request.installationName = this.installation.name;
                request.configurationToExport = this.referenceConfiguration;
                request.templateContent = templateContent;
                request.templateName = templateName;
                let response: ApiGenericResponse = await new ExportTemplateCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.exportedCorrectly", { templateName: templateName });
                        this.alertType = "success";
                        this.showAlert = true;
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending GetImportableTemplate request ", e);
            }
            this.loadingExport = false;
            this.showExportTemplateDialog = false;
        },
        async openImportConfigurationDialog() {
            this.showImportTemplateDialog = true;
            this.loadingImport = true;
            try {
                let request = new GetImportableTemplateReqData();
                request.installationName = this.installation.name;
                request.templateContent = TemplateContentEnum.Rollconfig;

                let response: GetImportableTemplateResData = await new GetImportableTemplateCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.importableTemplates = response.importableTemplates;
                }
            } catch (e) {
                console.log("Something went wrong sending GetImportableTemplate request ", e);
            }
            this.loadingImport = false;
        },
        async forceUpdate() {
            this.showForceDialog = false;
            if (!this.isDifferentFromDb) return;
            try {
                let request = new UpdateSecurityConfigurationNowReqData();
                request.installationName = this.installation.name;

                let res: ApiGenericResponse = await new UpdateSecurityConfigurationNowCommand(request).execute();
                if (res.message) {
                    switch (res.message) {
                        case CReqExecutionResultEnum.Ok:
                            this.alertMessage = this.$t("security_management.commandSent");
                            this.alertType = "success";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.AgentOffline:
                            this.alertMessage = this.$t("security_management.agentOfflineForInstallation");
                            this.alertType = "warning";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.AgentNotInstalled:
                            this.alertMessage = this.$t("security_management.agentNotInstalled");
                            this.alertType = "error";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.DeviceLocked:
                            this.alertMessage = this.$t("security_management.agentLocked");
                            this.alertType = "warning";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.OperationNotAvailable:
                            this.alertMessage = this.$t("security_management.operationNotAvailable");
                            this.alertType = "info";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.FileNotFound:
                            this.alertMessage = this.$t("security_management.fileNotFound");
                            this.alertType = "error";
                            this.showAlert = true;
                            break;
                        case CReqExecutionResultEnum.ServerError:
                            this.alertMessage = this.$t("device_status.serverError");
                            this.alertType = "error";
                            this.showAlert = true;
                            break;
                        default:
                            break;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending UpdateSecurityConfigurationNow request ", e);
            }
        },
        async revertConfiguration() {
            this.loadingRevert = true;
            try {
                let response: RevertInstallationSecurityConfigurationResData = await new RevertInstallationSecurityConfigurationCommand(this.installation.name, true).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.message == CReqExecutionResultEnum.Ok) {
                        this.alertMessage = this.$t("security_management.revertedCorrectly");
                        this.alertType = "success";
                        this.showAlert = true;
                        this.referenceConfiguration = response.referenceConfiguration.configuration;
                        this.$emit("reload-table");
                    } else {
                        this.alertMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        this.showAlert = true;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending RevertInstallationSecurityConfiguration request ", e);
            }
            this.loadingRevert = false;
            this.showRevertDialog = false;
        },
        updateShowExportDialog(newVal: Boolean) {
            this.showExportTemplateDialog = newVal;
        },
        saveConfiguration() {
            this.editMode = false;
            let newConfiguration: Configuration = new Configuration();
            for (let i = 0; i < this.localStockConfiguration.length; i++) {
                let stock = this.localStockConfiguration[i];
                let options = this.localStockOptions[i].options;
                let cashIn = options.filter((o) => o.label == this.$t("stocks_config.cashIn"));
                if (cashIn && cashIn.length == 1) stock.cashIn = cashIn[0].isChecked;
                let counterfeit = options.filter((o) => o.label == this.$t("stocks_config.counterfeit"));
                if (counterfeit && counterfeit.length == 1) stock.counterfeit = counterfeit[0].isChecked;
                let exceed = options.filter((o) => o.label == this.$t("stocks_config.exceed"));
                if (exceed && exceed.length == 1) stock.exceed = exceed[0].isChecked;
                let suspect = options.filter((o) => o.label == this.$t("stocks_config.suspect"));
                if (suspect && suspect.length == 1) stock.suspect = suspect[0].isChecked;
                let unfit = options.filter((o) => o.label == this.$t("stocks_config.unfit"));
                if (unfit && unfit.length == 1) stock.unfit = unfit[0].isChecked;
            }
            newConfiguration.delays = this.referenceConfiguration.delays;
            newConfiguration.alarms = this.referenceConfiguration.alarms;
            newConfiguration.timeBands = this.referenceConfiguration.timeBands;
            newConfiguration.rollsConfig = this.localStockConfiguration;
            this.sendRequest(newConfiguration);
        },
        getStockFromIndex(index: number) {
            if (this.referenceConfiguration && this.referenceConfiguration.rollsConfig) {
                let stock = this.referenceConfiguration.rollsConfig.filter((s) => s.index == index);
                if (stock && stock.length == 1) return stock[0];
            }
            return null;
        },
        enterEditMode() {
            this.editMode = true;
            this.localStockConfiguration = new Array<Stock>();
            this.localStockOptions = [];
            this.selectedStock = 0;
            for (let stock of this.stockConfiguration) {
                let localStock = new Stock();
                localStock.clone(stock);
                this.localStockConfiguration.push(localStock);

                let options = [];
                let readOnly = false;
                let cashInChecked = stock.cashIn;
                if (stock.stockType == StockTypeEnum.Bag) {
                    readOnly = true;
                    cashInChecked = true;
                }
                if (stock.suspect || stock.counterfeit || stock.unfit) cashInChecked = true;
                options.push({ label: this.$t("stocks_config.cashIn"), isChecked: cashInChecked, readOnly: readOnly });
                options.push({ label: this.$t("stocks_config.exceed"), isChecked: stock.exceed });
                options.push({ label: this.$t("stocks_config.suspect"), isChecked: stock.suspect });
                options.push({ label: this.$t("stocks_config.counterfeit"), isChecked: stock.counterfeit });
                options.push({ label: this.$t("stocks_config.unfit"), isChecked: stock.unfit });
                this.localStockOptions.push({ index: stock.index, options: options, type: stock.stockType });
            }
        },
        addDenominations() {
            if (this.denominationsToAdd && this.denominationsToAdd.length) {
                for (let denominationToAdd of this.denominationsToAdd) {
                    let splittedDen = denominationToAdd.split(";");
                    let cur = splittedDen[0];
                    let val = splittedDen[1];
                    let rev = splittedDen[2];
                    let den = this.filteredDenomination.filter((d) => d.currency == cur && d.value == val && d.revision == rev);

                    if (den && den.length == 1) {
                        if (this.localStockConfiguration[this.selectedStock].denominations == null || this.localStockConfiguration[this.selectedStock].denominations == undefined)
                            this.localStockConfiguration[this.selectedStock].denominations = new Array<Denomination>();
                        let existingDen = this.localStockConfiguration[this.selectedStock].denominations.filter((d) => d.currency == cur && d.value == val && d.revision == rev);
                        if (!existingDen || existingDen.length == 0) this.localStockConfiguration[this.selectedStock].denominations.push(den[0]);
                    }
                }
                this.clearSelection(false);
                let stockDenomination = this.localStockConfiguration[this.selectedStock].denominations;
                if (
                    stockDenomination.length > 1 &&
                    stockDenomination.filter((d) => d.currency == stockDenomination[0].currency && d.value == stockDenomination[0].value).length != stockDenomination.length
                ) {
                    this.localStockOptions[this.selectedStock].options[0].isChecked = true;
                    this.canDeselectCashIn[this.selectedStock] = false;
                }
            }
        },
        removeDenominations() {
            if (this.denominationsToRemove && this.denominationsToRemove.length) {
                for (let denominationToRemove of this.denominationsToRemove) {
                    let splittedDen = denominationToRemove.split(";");
                    let cur = splittedDen[0];
                    let val = splittedDen[1];
                    let rev = splittedDen[2];
                    let denIndex = -1;
                    if (splittedDen[2] == "null")
                        denIndex = this.localStockConfiguration[this.selectedStock].denominations.findIndex((d) => d.currency == cur && d.value == val && d.revision == null);
                    else denIndex = this.localStockConfiguration[this.selectedStock].denominations.findIndex((d) => d.currency == cur && d.value == val && d.revision == rev);
                    if (denIndex != -1) {
                        this.localStockConfiguration[this.selectedStock].denominations.splice(denIndex, 1);
                    }
                }
                this.clearSelection(true);
                let stockDenomination = this.localStockConfiguration[this.selectedStock].denominations;

                if (
                    stockDenomination.length <= 1 ||
                    stockDenomination.filter((d) => d.currency == stockDenomination[0].currency && d.value == stockDenomination[0].value).length == stockDenomination.length
                ) {
                    let found = false;
                    for (let i = 1; i < this.localStockOptions[this.selectedStock].options.length; i++) {
                        if (this.localStockOptions[this.selectedStock].options[i].isChecked) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) this.canDeselectCashIn[this.selectedStock] = true;
                }
            }
        },
        selectAll(fromStock) {
            if (!fromStock) {
                for (let denomination of this.filteredDenomination) {
                    this.denominationsToAdd.push(denomination.currency + ";" + denomination.value + ";" + denomination.revision);
                }
            } else {
                for (let denomination of this.localStockConfiguration[this.selectedStock].denominations) {
                    this.denominationsToRemove.push(denomination.currency + ";" + denomination.value + ";" + denomination.revision);
                }
            }
        },
        clearSelection(fromStock) {
            if (fromStock) this.denominationsToRemove = [];
            else this.denominationsToAdd = [];
        },
        optionChanged(stockIndex, optionIndex) {
            if (optionIndex > 0 && this.localStockOptions[stockIndex].options[optionIndex]) this.localStockOptions[stockIndex].options[0].isChecked = true;
        },
    },
    mounted() {
        this[GET_ALL_DENOMINATIONS]();
    },
});
